import { useEffect, useRef, useState } from "react";
import { useApp } from "@/context/AppContext";
import { Music, VolumeX } from "lucide-react";

export function BackgroundMusic() {
  const { settings } = useApp();
  const url = settings?.music_url || "";
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    if (!url) return;
    const a = ref.current;
    if (!a) return;
    a.volume = 0.25;
    const tryPlay = () => a.play().then(() => setPlaying(true)).catch(() => {});
    tryPlay();
    const onFirst = () => { if (a.paused) tryPlay(); };
    window.addEventListener("pointerdown", onFirst, { once: true });
    return () => window.removeEventListener("pointerdown", onFirst);
  }, [url]);

  if (!url) return null;

  const toggle = () => {
    const a = ref.current;
    if (!a) return;
    if (a.paused) a.play().then(() => setPlaying(true)).catch(() => {});
    else { a.pause(); setPlaying(false); }
  };

  return (
    <>
      <audio ref={ref} src={url} loop preload="auto" />
      <button onClick={toggle} data-testid="music-toggle-btn" title={playing ? "Mute music" : "Play music"}
        className="fixed bottom-36 lg:bottom-24 right-4 lg:right-6 z-40 w-12 h-12 rounded-full bg-forest text-cream shadow-lg flex items-center justify-center hover:bg-earth transition-colors">
        {playing ? <Music className="w-5 h-5" /> : <VolumeX className="w-5 h-5" />}
      </button>
    </>
  );
}
